"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMenuButton = exports.MenuButton = void 0;
const lib_es2015_1 = require("@hodol/dom-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/web-component-helper/lib-es2015");
class MenuButton extends HTMLElement {
    constructor() {
        super();
        const color = (0, lib_es2015_1.getAttributeOrDefault)(this, 'color', '#ffffff');
        const width = (0, lib_es2015_1.getAttributeOrDefault)(this, 'width', '24px');
        const height = (0, lib_es2015_1.getAttributeOrDefault)(this, 'height', '24px');
        this.style.setProperty('display', 'inline-block');
        this.style.setProperty('width', width);
        this.style.setProperty('height', height);
        this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path d="M4 18L20 18" stroke="${color}" stroke-width="2" stroke-linecap="round"/>
      <path d="M4 12L20 12" stroke="${color}" stroke-width="2" stroke-linecap="round"/>
      <path d="M4 6L20 6" stroke="${color}" stroke-width="2" stroke-linecap="round"/>
    </svg>`;
    }
}
exports.MenuButton = MenuButton;
const defineMenuButton = (name) => {
    (0, lib_es2015_2.defineIfUndefined)(name, MenuButton);
};
exports.defineMenuButton = defineMenuButton;
